import React from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import { CloseBtn, Title } from '../UI/Modal';

const CartAddedModal = ({ open, onClose }) => {
    return (
        <Modal isOpen={open} onClose={onClose} onRequestClose={onClose} className="Modal cart-added-modal" ariaHideApp={false}>
            <CloseBtn onClose={onClose} />
            <Box mb={5}>
                <Title align="center">Успешно добавлено!</Title>
            </Box>
            <Box width="100%">
                <Link to="/cart">
                    <Button variant="outlined" color="primary">
                        Перейти к корзине
                    </Button>
                </Link>
            </Box>
        </Modal>
    );
};

export default CartAddedModal;
